import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import type React from "react";
import Button from "~/components/ui/button";
import Modal from "~/components/ui/modal";
import { DOCUMENT_TYPES } from "~/config/documents";
import { useAppSelector } from "~/hooks";
import type { DocumentType } from "~/interface/document";
import styles from "./GenerateConfirmModal.module.scss";

type GenerateConfirmModalProps = {
  isOpen: boolean;
  documentType: DocumentType;
  onConfirm: () => void;
  onClose: () => void;
};

export const GenerateConfirmModal: React.FC<GenerateConfirmModalProps> = ({
  isOpen,
  documentType,
  onConfirm,
  onClose,
}) => {
  const remainingCredit = useAppSelector((state) => state.auth.organization.remainingCredit);
  const docConfig = DOCUMENT_TYPES[documentType as keyof typeof DOCUMENT_TYPES];
  const documentName = docConfig?.name ?? documentType;
  const creditCost = docConfig?.creditUsage?.generate ?? 0;

  return (
    <Modal
      label="ドキュメント生成の確認"
      isOpen={isOpen}
      onClose={onClose}
      content={
        <div className={styles["modalContent"]}>
          <div className={styles["iconWrapper"]}>
            <AutoAwesomeIcon sx={{ fontSize: 40 }} />
          </div>
          <p className={styles["description"]}>「{documentName}」を生成します。</p>
          <div className={styles["creditInfo"]}>
            <div className={styles["creditRow"]}>
              <span className={styles["creditLabel"]}>消費クレジット</span>
              <span className={styles["creditValue"]}>{creditCost} クレジット</span>
            </div>
            <div className={styles["creditRow"]}>
              <span className={styles["creditLabel"]}>残りクレジット</span>
              <span className={styles["creditValueRemaining"]}>{remainingCredit} クレジット</span>
            </div>
          </div>
          <div className={styles["buttonContainer"]}>
            <Button styleType="white-middle" label="キャンセル" onClick={onClose} />
            <Button styleType="blue-middle" label="生成する" onClick={onConfirm} />
          </div>
        </div>
      }
    />
  );
};
